import "./instrument";
import "./main.scss";
import "./index.css";
import React from "react";
import { createRoot } from "react-dom/client";
import de_DE from "antd/locale/de_DE";
import dayjs from "dayjs";
import localeData from "dayjs/plugin/localeData";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekYear from "dayjs/plugin/weekYear";
import duration from "dayjs/plugin/duration";
import isBetween from "dayjs/plugin/isBetween";
import isoWeek from "dayjs/plugin/isoWeek";
import minMax from "dayjs/plugin/minMax";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { BrowserRouter } from "react-router-dom";
import "dayjs/locale/de";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import AuthProvider from "./auth/authProvider";
import App from "./App";
import { trpc, trpcClient } from "./api/trpc";
import UserStoreHydrator from "./components/util/UserStoreHydrator";

dayjs.locale("de");
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);
dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);
dayjs.extend(isBetween);
dayjs.extend(isoWeek);
dayjs.extend(minMax);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

dayjs.tz.setDefault("Europe/Berlin");

// Create a client for react-query
const queryClient = new QueryClient();

const root = createRoot(document.getElementById("root")!);
if (window.location.hostname.includes("admin.samson.kalialab.de")) {
  window.location.href = "https://admin.booking.kalialab.de";
}
root.render(
  <React.StrictMode>
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <BrowserRouter>
            <App />
            {/* <Toaster /> */}
            <UserStoreHydrator />
          </BrowserRouter>
        </AuthProvider>
      </QueryClientProvider>
    </trpc.Provider>
  </React.StrictMode>,
);
